import { render } from "./PresentationPage.vue?vue&type=template&id=50481330"
const script = {}

import "./PresentationPage.vue?vue&type=style&index=0&id=50481330&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__